import { useEffect, useRef } from 'react';
import styles from './CaseStudy.module.scss';
import AutoSlider from 'components/home/CaseStudy/AutoSlider';
import Button from 'components/commons/Button/Button';
import BasicTitle from 'components/commons/BasicTitle/BasicTitle';
import { gsap, Power1 } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const tweenVars: gsap.TweenVars = {
  y: '50',
  duration: 0.5,
  opacity: 0,
  ease: Power1.easeOut,
};

type CaseStudyProps = {
  enTitle?: string;
  jaTitle?: string;
  tagType?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
};

const CaseStudy: React.FC<CaseStudyProps> = ({ enTitle = 'Case study', jaTitle = '事例', tagType = 'h3' }) => {
  const timeline = gsap.timeline();
  const button = useRef<HTMLDivElement>(null);

  useEffect(() => {
    timeline
      .from('.Case_title', tweenVars, 0.3)

    ScrollTrigger.create({
      animation: timeline,
      trigger: '.Case_title',
      start: 'top 90%',
      toggleActions: 'play none none play',
    });
  }, []);

  const sectionTitle = {
    title: enTitle,
    sub_title: jaTitle,
  };

  return (
    <section className={styles.wrapper}>
      <div className={styles.inner}>
        <BasicTitle sectionTitle={sectionTitle} tagType={tagType} />
      </div>
      <div className={`${styles.autoSlider} autoSlider`}>
        <AutoSlider />
      </div>
      <div className={`${styles.inner} Case_btn`}>
        <div className={styles.btn} ref={button}>
          <Button text="事例一覧" href="/cases" />
        </div>
      </div>
    </section>
  );
};

export default CaseStudy;

